export const actionTypes = {
  CERTIFICATION_CONFIGURATIONS_REQUEST: "CERTIFICATION_CONFIGURATIONS_REQUEST",
  CERTIFICATION_CONFIGURATIONS_REQUEST_SUCCESS:
    "CERTIFICATION_CONFIGURATIONS_REQUEST_SUCCESS",
  CERTIFICATION_CONFIGURATIONS_REQUEST_FAILURE:
    "CERTIFICATION_CONFIGURATIONS_REQUEST_FAILURE",
  CONFIGURATION_ENRICHMENT_REQUEST: "CONFIGURATION_ENRICHMENT_REQUEST",
  CONFIGURATION_ENRICHMENT_REQUEST_SUCCESS:
    "CONFIGURATION_ENRICHMENT_REQUEST_SUCCESS",
  CONFIGURATION_ENRICHMENT_REQUEST_FAILURE:
    "CONFIGURATION_ENRICHMENT_REQUEST_FAILURE",
  SET_SELECTED_CERTIFICATION_CONFIGURATION:
    "SET_SELECTED_CERTIFICATION_CONFIGURATION",
};

export const certificationConfigurationsRequest = (payload: any) => ({
  type: actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST,
  payload,
});

export const certificationConfigurationsRequestSuccess = (payload: any) => ({
  type: actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST_SUCCESS,
  payload,
});

export const certificationConfigurationsRequestFailure = (err: Error) => ({
  type: actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST_FAILURE,
  err,
});

export const configurationEnrichmentRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATION_ENRICHMENT_REQUEST,
  payload,
});

export const configurationEnrichmentRequestSuccess = (payload: any) => ({
  type: actionTypes.CONFIGURATION_ENRICHMENT_REQUEST_SUCCESS,
  payload,
});

export const configurationEnrichmentRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATION_ENRICHMENT_REQUEST_FAILURE,
  err,
});

export const setSelectedCertificationConfiguration = (payload: any) => ({
  type: actionTypes.SET_SELECTED_CERTIFICATION_CONFIGURATION,
  payload,
});
